<template>
  <div>
    <!-- Misma tarjeta, misma grilla y mismo orden de campos que el formulario de ArcGIS: editar
         una capa de un proveedor u otro no debe parecer entrar a dos sistemas distintos (QA-72). -->
    <div class="card">
      <div class="card-header">
        <h2>Datos de la capa</h2>
      </div>

      <div class="card-body">
        <div class="form-grid">

          <div class="form-row">
            <label for="geoserver-layer-name">Nombre <span class="required-indicator">*</span><FieldHelp label="el nombre de la capa" :text="help.nombre" /></label>
            <input
              id="geoserver-layer-name"
              type="text"
              class="input"
              v-model="layerData.name"
            />
          </div>

          <div class="form-row">
            <label for="geoserver-description">Descripción <span class="required-indicator">*</span><FieldHelp label="la descripción" :text="help.descripcion" /></label>
            <textarea
              id="geoserver-description"
              class="input"
              rows="4"
              v-model="layerData.description"
            ></textarea>
          </div>

          <div class="form-row">
            <label for="geoserver-url">Url <span class="required-indicator">*</span><FieldHelp label="la URL del servicio" :text="help.url" /></label>
            <div>
              <input
                id="geoserver-url"
                type="url"
                class="input"
                v-model="layerData.url"
              />
              <small class="error-text" v-if="layerData.url && urlError">{{ urlError }}</small>
            </div>
          </div>

          <div class="form-row">
            <label for="geoserver-workspace">Espacio de trabajo <span class="required-indicator">*</span><FieldHelp label="el espacio de trabajo" :text="help.workspace" /></label>
            <input
              id="geoserver-workspace"
              type="text"
              class="input"
              v-model="layerData.workspace"
            />
          </div>

          <div class="form-row">
            <label for="geoserver-datastore">Almacén de datos <span class="required-indicator">*</span><FieldHelp label="el almacén de datos" :text="help.datastore" /></label>
            <input
              id="geoserver-datastore"
              type="text"
              class="input"
              v-model="layerData.datastore"
            />
          </div>

          <div class="form-row">
            <label for="geoserver-fuente">Fuente<FieldHelp label="la fuente" :text="help.fuente" /></label>
            <input
              id="geoserver-fuente"
              type="text"
              class="input"
              v-model="layerData.fuente"
            />
          </div>

          <div class="form-row">
            <label for="geoserver-fecha-dato">Fecha del dato</label>
            <input
              id="geoserver-fecha-dato"
              type="date"
              class="input"
              v-model="layerData.fechaDato"
            />
          </div>

          <div class="form-row">
            <label for="geoserver-fecha-actualizacion">Fecha de actualización</label>
            <input
              id="geoserver-fecha-actualizacion"
              type="date"
              class="input"
              v-model="layerData.fechaActualizacion"
            />
          </div>

          <!-- Los dos campos de geoproceso sólo se ofrecen para el proveedor geoserver: el servicio
               de geoprocesos registra únicamente geoserver y arcgis, y una capa de proveedor 'file'
               marcada como vulnerable fallaría recién al ejecutar el análisis (QA-72). -->
          <template v-if="isGeoserverProvider">
            <div class="form-row">
              <label for="geoserver-vulnerable">I. vulnerable Modelación/Geoprocesos? <span class="required-indicator">*</span><FieldHelp label="vulnerable a modelación y geoprocesos" :text="help.esVulnerable" /></label>
              <select id="geoserver-vulnerable" class="input" v-model="layerData.esVulnerable">
                <option value="NO">NO</option>
                <option value="SI">SI</option>
              </select>
            </div>

            <VulnerableReportIconField
              v-model="layerData.reportIconSvg"
              :vulnerable="layerData.esVulnerable === 'SI'"
            />

            <div class="form-row">
              <label for="geoserver-cap-poblacion">Cap población <span class="required-indicator">*</span><FieldHelp label="la capa de población" :text="help.capPoblacion" /></label>
              <select id="geoserver-cap-poblacion" class="input" v-model="layerData.capPoblacion">
                <option value="poligonos">Polígonos</option>
                <option value="puntos">Puntos</option>
                <option value="NO">NO</option>
              </select>
            </div>
          </template>

          <div class="form-row">
            <label for="geoserver-category">Categoría <span class="required-indicator">*</span><FieldHelp label="la categoría" :text="help.categoria" /></label>
            <select id="geoserver-category" class="input" v-model="layerData.id_category" @change="onCategoryChange">
              <option value="-1" disabled>
                {{ categories.length === 0 ? 'Cargando opciones...' : 'Seleccione una categoría' }}
              </option>
              <option v-for="category in categories" :key="category.id" :value="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="form-row">
            <label for="geoserver-order">Orden dentro de la categoría <span class="required-indicator">*</span><FieldHelp label="el orden dentro de la categoría" :text="help.orden" /></label>
            <LayerOrderFormModal
              id="geoserver-order"
              :category-id="layerData.id_category"
              :category-name="selectedCategoryName"
              :current-layer-id="currentLayerId"
              :current-layer-name="layerData.name"
              :value="layerData.orden"
              :layer-order-ids="layerData.layerOrderIds"
              @input="layerData.orden = $event"
              @order-change="layerData.layerOrderIds = $event"
            />
          </div>

          <p class="note"><span class="required-indicator">(*)</span> Obligatorio</p>
        </div>
      </div>
    </div>

    <template v-if="isEdit">
      <label for="checkbox-status">Estado</label>
      <div id="status">
        <input type="checkbox" id="checkbox-status" :checked="initialData.status !== false" @change="$emit('toggle-status', $event)">
        <label for="checkbox-status">Activa</label>
      </div>
    </template>

    <div class="container-action-left" style="justify-content: end; margin-top: 20px">
      <button class="btn btn-secondary" v-on:click="onClickGoBack()" :disabled="isSaving">Volver</button>
      <button class="btn btn-primary" v-on:click="onClickGoNext()" :disabled="isSaving">
        <span v-if="isSaving">Guardando...</span>
        <span v-else>{{ isEdit ? 'Guardar cambios' : 'Crear capa' }}</span>
      </button>
    </div>
  </div>
</template>

<script>

import {restLayer} from '@/components/mixin/restLayer.js'
import {formatter} from '@/components/mixin/formatter.js'
import LayerOrderFormModal from './LayerOrderFormModal.vue'
import FieldHelp from '@/components/FieldHelp.vue'
import { LAYER_FIELD_HELP } from './layerFieldHelp.js'
import { resolveLayerGeometryFamily } from '@/services/layers/geometryType.js'
import VulnerableReportIconField from './VulnerableReportIconField.vue'


export default {
  name: "FormularioGeoserver",
  mixins: [formatter,  restLayer],
  components: { LayerOrderFormModal, FieldHelp, VulnerableReportIconField },
  data() {
    return {
      help: LAYER_FIELD_HELP,
      isSaving: false,
      layerData: {
        name: "",
        description: "",
        url: "",
        workspace: "",
        datastore: "",
        id_category: "-1",
        orden: 0,
        layerOrderIds: null,
        fuente: "",
        fechaDato: "",
        fechaActualizacion: "",
        esVulnerable: "NO",
        reportIconSvg: "",
        capPoblacion: "NO",
      },
    };
  },
  props: {
    categories: {
      type: Array,
      required: false,
      default: () => [],
    },
    layerCreationMode: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    initialData: {
      handler(newVal) {
        if (this.isEdit && newVal) {
          this.populateForm(newVal);
        }
      },
      deep: true,
      immediate: true,
    }
  },

  computed: {
    currentLayerId() {
      if (!this.isEdit) return ''
      return this.initialData.id || this.initialData._id || this.$route.params.idLayer || ''
    },
    selectedCategoryName() {
      const category = this.categories.find(item => item.id === this.layerData.id_category)
      return category ? category.name : ''
    },
    isGeoserverProvider() {
      return this.layerCreationMode === 'geoserver'
    },
    // Mismo aviso en línea que el formulario de ArcGIS, sin la regla del índice de subcapa:
    // en GeoServer la URL apunta a la raíz del servicio y no lleva número al final.
    urlError() {
      const url = this.layerData.url
      if (!url) return null
      if (!/^https?:\/\//i.test(url)) return 'La URL debe comenzar con http:// o https://'
      if (url.endsWith('/')) return "La URL no debe terminar en '/' (slash)"
      return null
    }
  },

  methods: {
    populateForm(data) {
      this.layerData = {
        name: data.name || "",
        description: data.desc || "",
        url: data.provider.url || "",
        workspace: data.provider.geoserverdata.workspace || "",
        datastore: data.provider.geoserverdata.datastore || "",
        id_category: data.id_category || "-1",
        orden: data.orden ? parseInt(data.orden, 10) : 0,
        layerOrderIds: null,
        fuente: data.fuente || "",
        fechaDato: this.dateInputFormatter(data.fecha_dato),
        fechaActualizacion: this.dateInputFormatter(data.fecha_actualizacion),
        esVulnerable: data.es_vulnerable || "NO",
        reportIconSvg: data.report_icon_svg || "",
        capPoblacion: data.cap_poblacion || "NO",
      };
    },
    onCategoryChange() {
      this.layerData.orden = 0
      this.layerData.layerOrderIds = null
    },
    onClickGoBack: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/capas/");
    },
    // Los avisos van por el toast del sistema y no por alert(), igual que en ArcGIS.
    notify(message, type = 'warning') {
      this.$store.dispatch('toast/show', { message, type })
    },
    onClickGoNext: async function () {
      // Nombre, descripción y URL ya eran obligatorios en el backend (validateAndParseLayer):
      // sin estos avisos el formulario dejaba enviar y la pantalla sólo mostraba un 422.
      if (!this.layerData.name || !this.layerData.description) {
        this.notify('Completa los campos obligatorios: Nombre y Descripción.')
        return
      }
      if (!this.layerData.url) {
        this.notify('Debes ingresar la URL del servicio.')
        return
      }
      if (this.urlError) {
        this.notify(this.urlError)
        return
      }
      if (!this.layerData.workspace || !this.layerData.datastore) {
        this.notify('Debes indicar el espacio de trabajo y el nombre de la capa en GeoServer.')
        return
      }
      if (!this.layerData.id_category || this.layerData.id_category === '-1') {
        this.notify('Debes seleccionar una categoría.')
        return
      }
      this.layer.provider.name= this.layerCreationMode; // geoserver o arcgis
      this.layer.provider.geoserverdata.workspace = this.layerData.workspace;
      this.layer.provider.geoserverdata.datastore = this.layerData.datastore;
      this.layer.desc = this.layerData.description;
      this.layer.id_category = this.layerData.id_category;
      this.layer.name = this.layerData.name;
      this.layer.orden = String(this.layerData.orden);
      this.layer.layerOrderIds = this.layerData.layerOrderIds;
      this.layer.provider.url = this.layerData.url;
      this.layer.fuente = this.layerData.fuente;
      this.layer.fecha_dato = this.optionalDatePayload(this.layerData.fechaDato);
      this.layer.fecha_actualizacion = this.optionalDatePayload(this.layerData.fechaActualizacion);

      // Los campos de geoproceso no se envían si el formulario no los mostró: en el modelo
      // llevan omitempty, así que omitirlos conserva el valor guardado en vez de pisarlo (QA-72).
      if (this.isGeoserverProvider) {
        this.layer.es_vulnerable = this.layerData.esVulnerable;
        this.layer.report_icon_svg = this.layerData.reportIconSvg;
        this.layer.cap_poblacion = this.layerData.capPoblacion;
      }

      // La consulta del tipo geométrico habla con el proveedor y puede tardar: sin bloquear el
      // botón la pantalla se veía inerte y se podía enviar dos veces el mismo guardado.
      this.isSaving = true
      try {
        try {
          this.layer.geometry_type = await resolveLayerGeometryFamily(this.layer, { preferStored: false }) || this.layer.geometry_type || ''
        } catch (error) {
          // La metadata geométrica es informativa: una caída temporal del
          // proveedor no debe impedir guardar el resto de la capa.
          console.warn('No fue posible obtener el tipo geométrico de la capa:', error)
        }

        console.log("Se procesa layer de geoserver:", this.layer);

        if (this.isEdit) {
          console.log("Se edita layer:", this.layer);
          await this.putLayer();
        } else {
          console.log("Se crea layer:", this.layer);
          await this.postLayer();
        }
      } finally {
        this.isSaving = false
      }
    },
    getData() {
      return { ...this.layerData };
    },
    resetForm() {
      this.layerData = {
        name: "",
        description: "",
        url: "",
        workspace: "",
        datastore: "",
        id_category: "-1",
        orden: 0,
        layerOrderIds: null,
        fuente: "",
        fechaDato: "",
        fechaActualizacion: "",
        esVulnerable: "NO",
        reportIconSvg: "",
        capPoblacion: "NO",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_layerForm.scss";
</style>
